function t() {
}
function r() {
  return !0;
}
function e() {
  return !1;
}
function u(n) {
  return n;
}
function o(n) {
  n();
}
export {
  u as identity,
  o as invoke,
  t as noop,
  e as returnFalse,
  r as returnTrue
};
